var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncomeicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 1.64844H3.9974C3.64377 1.64844 3.30464 1.78891 3.05459 2.03896C2.80454 2.28901 2.66406 2.62815 2.66406 2.98177V13.6484C2.66406 14.0021 2.80454 14.3412 3.05459 14.5912C3.30464 14.8413 3.64377 14.9818 3.9974 14.9818H11.9974C12.351 14.9818 12.6902 14.8413 12.9402 14.5912C13.1903 14.3412 13.3307 14.0021 13.3307 13.6484V4.98177L9.9974 1.64844Z",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 1.64844V4.3151C9.33203 4.66873 9.47251 5.00786 9.72256 5.25791C9.9726 5.50796 10.3117 5.64844 10.6654 5.64844H13.332",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 6.31543H5.33203",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 8.98242H5.33203",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 11.6494H5.33203",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeicon);
export default __webpack_public_path__ + "static/media/incomeicon.fef4365d562d22ef67be0be03bf015a4.svg";
export { ForwardRef as ReactComponent };